import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import Accordion from 'components/Accordion';
import PromoVideoForm from './PromoVideoForm';

type Props = {
  defaultExpanded?: boolean;
}

const PromoVideo:FC<Props> = ({ defaultExpanded }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full" react-scroll="promoVideo">
      <Accordion label={t('pages.quizForm.promoVideoLabel')} icon="list" defaultExpanded={defaultExpanded}>
        <PromoVideoForm />
      </Accordion>
    </div>
  )
}

export default PromoVideo;
